<section id="section-why-finzy" class="row">
  <div class="row">
    <h2 class="heading col-xs-10 col-xs-offset-1">Eligibility Criteria</h2>
  </div>

  <div class="row">
    <div class="col-xs-10 col-xs-offset-1">

      <div class="row display-flex">
        <div class="col-xs-12 col-md-4 display-flex">
          <div class="block-item"><img src="../../../../assets/images/eligibility-criteria/india.svg">
            <span class="block-item-label">Citizen of India & over 18 years of age</span></div>
        </div>

        <div class="col-xs-12 col-md-4 display-flex">
          <div class="block-item"><img src="../../../../assets/images/eligibility-criteria/calendar.svg">
            <span class="block-item-label">Monthly salary greater than ₹35000 or Annual income greater than ₹5Lacs</span></div>
        </div>

        <div class="col-xs-12 col-md-4 display-flex">
          <div class="block-item"><img src="../../../../assets/images/eligibility-criteria/id-card.svg">
            <span class="block-item-label">Identity proof and address proof</span></div>
        </div>
      </div>

    </div>
  </div>
</section>
